import removeEntity from 'owa-controls-findpeople-feedback-manager/lib/actions/removeEntity';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';

/**
 * Removes a find people entity
 */
export default function removeFindPeopleEntity(
    feedbackManager: FeedbackManagerState,
    recipientEntity: ReadWriteRecipientViewState
) {
    if (recipientEntity && recipientEntity.isValid) {
        removeEntity(feedbackManager, [recipientEntity.persona.EmailAddress.EmailAddress]);
    }
}
